import {createSelector} from 'reselect';

const getUI = state => state.ui;

export default createSelector(
  [getUI],
  ui => ui.sections.indexOf('DELIVERY') === ui.checkoutProgressStep,
);
